import * as Sentry from "@sentry/react"

export function sentryInit()
{
	Sentry.init({
		dsn: "https://ba93f38fae9df06bc4f8a168750365bc@o4508796602155008.ingest.us.sentry.io/4508796603465728",
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration(),
		],

		// Tracing
		tracesSampleRate: 1.0, //  Capture 100% of the transactions

		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

		// Session Replay

		// This sets the sample rate at 10%. You may want to change it to 100% while in development
		// and then sample at a lower rate in production.
		replaysSessionSampleRate: 0,

		// If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions
		//  where errors occur.
		replaysOnErrorSampleRate: 1.0,
	})
}